import React from "react";
import {getManager} from "../../../ts/manager/Manager";
import {IRouteProps, IViewProps} from "../../../ts/manager/view/ViewInterface";
import NoInternetBodyPartial from "./NoInternetBodyPartial";
import Error404Partial from "./Error404Partial";
import Error403Partial from "./Error403Partial";

const ErrorConditionalPartial = (props:IRouteProps|IViewProps) =>
{
    if(getManager().api.hasNoInternetConnection){
        return <NoInternetBodyPartial {...props} />;
    }
    const authorizationIsExpected = !!(props as IRouteProps).choice?.routeIDs.authorization_is_expected;
    if(authorizationIsExpected){
        return <Error403Partial {...props} />;
    }
    return <Error404Partial {...props} />;
}

export default ErrorConditionalPartial;